@if (error) {
  <main
    class="mx-auto flex w-full max-w-7xl flex-auto flex-col justify-center py-12 sm:py-24"
    data-automationid="error-container"
  >
    <p class="text-base font-semibold leading-8 text-teal-500" data-automationid="error-code">{{ mapErrorCode() }}</p>
    <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl" data-automationid="error-message">
      {{ error.message }}
    </h1>
    @if (error.details) {
      <p class="mt-6 text-base leading-7 text-gray-600" data-automationid="error-details">
        {{ error.details }}
      </p>
    }
    @if (retry.observers.length > 0) {
      <div class="mt-10">
        <button
          type="button"
          (click)="retryClicked()"
          data-automationid="error-retry-link"
          class="text-sm font-semibold leading-7 text-teal-500 cursor-pointer hover:underline bg-transparent border-0 p-0"
        >
          Retry
        </button>
      </div>
    }
  </main>
}
